import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=8f7a9342&"
import script from "./ui-button.vue?vue&type=script&lang=js&"
export * from "./ui-button.vue?vue&type=script&lang=js&"
import style0 from "./ui-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7a9342')) {
      api.createRecord('8f7a9342', component.options)
    } else {
      api.reload('8f7a9342', component.options)
    }
    module.hot.accept("./ui-button.vue?vue&type=template&id=8f7a9342&", function () {
      api.rerender('8f7a9342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-button/ui-button.vue"
export default component.exports